import React from 'react';
import { G, Rect, Text as SvgText } from 'react-native-svg';
import { DT } from './tokens';

type Props = {
  formula: string;
  /** Bottom-left x position of the tag. Default: 14 */
  x?: number;
  /** Bottom y position (text baseline). Default: 248 (near bottom of 260px canvas) */
  y?: number;
};

/**
 * Formula badge rendered at the bottom of a diagram.
 * Shows the primary equation in monospace white on a semi-transparent dark strip.
 */
export function FormulaTag({ formula, x = 14, y = 248 }: Props) {
  return (
    <G>
      <Rect x={0} y={y - 18} width={DT.vw} height={26} fill="rgba(0,0,0,0.45)" />
      <SvgText
        x={x}
        y={y}
        fill={DT.formula}
        fontSize="12"
        fontFamily={DT.mono}
        fontWeight="600"
        letterSpacing={1}
      >
        {formula}
      </SvgText>
    </G>
  );
}
